/* Retro Craft — shared quick-add behaviour for product cards.
   Pairs with snippets/rc-quick-add.liquid and assets/rc-quick-add.css. */
(function () {
  'use strict';

  function updateCartBubble(count) {
    var link = document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      link.appendChild(bubble);
    }
    bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>' +
      '<span class="visually-hidden">' + count + ' item' + (count === 1 ? '' : 's') + '</span>';
  }

  function addToCart(btn, variantId, props) {
    if (!variantId) return;
    var original = btn.dataset.label || btn.textContent;
    btn.dataset.label = original;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [props ? { id: Number(variantId), quantity: 1, properties: props } : { id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Screen-reader announcement, where the page provides a live region for it.
        var status = document.querySelector('[data-cart-status]') || document.getElementById('rc-col-status');
        if (status) {
          status.textContent = 'Added to cart. ' + cart.item_count +
            ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart.';
        }

        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.textContent = original;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      });
  }

  function initGroup(root) {
    var variants;
    try {
      variants = JSON.parse(root.dataset.variants);
    } catch (e) {
      return; // Malformed data: leave the card as-is rather than breaking the grid.
    }
    if (!variants || !variants.length) return;

    var addBtn = root.querySelector('[data-qa-add]');
    var selected = (variants.find(function (v) { return v.a; }) || variants[0]).o.slice();

    var card = root.closest('[data-qa-card]');
    var cardImg = card && card.querySelector('[data-qa-image]');
    // Only swap the card image when variants actually differ — products that share
    // one image across every variant (the display stands) are left untouched.
    var distinctImages = variants.reduce(function (set, v) {
      if (v.img) set[v.img] = true;
      return set;
    }, {});
    var swapsImage = cardImg && Object.keys(distinctImages).length > 1;
    var lastImg = null;

    function showVariantImage(variant) {
      if (!swapsImage || !variant || !variant.img || variant.img === lastImg) return;
      lastImg = variant.img;
      var next = new Image();
      next.onload = function () {
        // srcset would otherwise win over the new src and snap back the old image.
        cardImg.removeAttribute('srcset');
        cardImg.removeAttribute('sizes');
        cardImg.src = variant.img;
        cardImg.style.opacity = '';
      };
      next.onerror = function () { cardImg.style.opacity = ''; };
      cardImg.style.transition = 'opacity 140ms ease';
      cardImg.style.opacity = '0.35';
      next.src = variant.img;
    }

    function currentVariant() {
      return variants.find(function (v) {
        return v.o.every(function (value, i) { return value === selected[i]; });
      });
    }

    function sync() {
      root.querySelectorAll('.rc-qa__swatch').forEach(function (sw) {
        var active = selected[Number(sw.dataset.qaOpt)] === sw.dataset.value;
        sw.classList.toggle('is-active', active);
        sw.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      root.querySelectorAll('.rc-qa__select').forEach(function (sel) {
        sel.value = selected[Number(sel.dataset.qaOpt)];
      });

      var variant = currentVariant();
      showVariantImage(variant);

      // Backorder is per variant, so the card badge follows the selection.
      var backBadge = card && card.querySelector('[data-qa-backorder]');
      if (backBadge) backBadge.hidden = !(variant && variant.a && variant.b);

      if (!addBtn) return;
      if (variant && variant.a) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        addBtn.dataset.label = 'Add to Cart';
        addBtn.dataset.variantId = variant.id;
      } else {
        addBtn.disabled = true;
        addBtn.textContent = variant ? 'Sold Out' : 'Unavailable';
        delete addBtn.dataset.variantId;
      }
    }

    root.querySelectorAll('.rc-qa__swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        selected[Number(sw.dataset.qaOpt)] = sw.dataset.value;
        sync();
      });
    });
    root.querySelectorAll('.rc-qa__select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        selected[Number(sel.dataset.qaOpt)] = sel.value;
        sync();
      });
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-qa]').forEach(initGroup);

    // Single-variant cards carry the id directly on the button.
    document.querySelectorAll('[data-qa-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Products tagged usb-pd-ack (USB-C power cables, adapters, replacement PSU boards) need the customer to confirm
        // they will use a matching USB PD charger first (snippets/rc-pd-ack.liquid).
        var holder = btn.closest('[data-pd-ack]') || (btn.hasAttribute('data-pd-ack') ? btn : null);
        if (!holder) return addToCart(btn, btn.dataset.variantId);
        var sel = holder.querySelector('.rc-qa__select');
        var version = sel ? Array.prototype.map.call(holder.querySelectorAll('.rc-qa__select'), function (s) { return s.value; }).join(' / ') : '';
        var ask = window.RCPD ? window.RCPD.ask({ product: holder.getAttribute('data-pd-ack'), version: version })
          : Promise.resolve(window.confirm('Please confirm: you must use a USB PD charger that matches the requirements of this item. The wrong charger may cause permanent damage.'));
        ask.then(function (ok) { if (ok) addToCart(btn, btn.dataset.variantId, window.RCPD ? window.RCPD.props() : null); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
